import { render, staticRenderFns } from "./TraxAccountBasicClientCrud.vue?vue&type=template&id=4ec29d62"
import script from "./TraxAccountBasicClientCrud.vue?vue&type=script&lang=js"
export * from "./TraxAccountBasicClientCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports